import { connect } from 'react-redux'
import View from './Logo'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const Logo = connect(mapStateToProps)(View)

export default Logo
